import type { RunStatus } from './types';

/** Shared run-status → Badge variant mapping — used by Scans.tsx, RunDetail.tsx, and Dashboard.tsx. */
export const RUN_STATUS_VARIANT: Record<RunStatus, 'neutral' | 'warning' | 'success' | 'active' | 'danger'> = {
  queued: 'neutral',
  discovery: 'active',
  validation: 'active',
  reporting: 'active',
  completed: 'success',
  failed: 'danger',
  cancelled: 'neutral',
  paused: 'warning',
};
